var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDonate = function SvgDonate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.069 0a5.084 5.084 0 1 0 0 10.169 5.084 5.084 0 0 0 0-10.169Zm.722 7.27h-1.454V2.908h1.454V7.27ZM23.45 16.223a2.142 2.142 0 0 0-2.092-1.682h-4.495c.073.344.109.695.109 1.047v.727a.727.727 0 0 1-.727.727H7.52v-1.454h7.998a3.635 3.635 0 0 0-3.635-3.635H7.185a5.43 5.43 0 0 0-4.027-1.774H.25v7.997l6.682 3.344a5.816 5.816 0 0 0 4.234.38l10.793-3.158a2.141 2.141 0 0 0 1.49-2.52Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDonate;